import * as React from 'react';
import { classes, style } from 'typestyle';
import { inject, deps, observer, ComponentProps } from '../../../../lib/component';
import { YouTubeVideoTrackCarousel } from '../../molecules/YouTubeVideoTrackCarousel';
import { Loading } from '../../../loading/loading';
import { LOAD_STATE } from '../../../../types/api';

const styles = {
  wrapper: style({
    position: 'relative',
  }),
};

export type YouTubeVideoTrackCarouselSliceProps = ComponentProps & { className?: string };

export const YouTubeVideoTrackCarouselSlice: React.FC<YouTubeVideoTrackCarouselSliceProps> = inject(deps)(
  observer(
    ({
      className,
      model: {
        webContent: { featuredVideos, featuredVideosStatus },
      },
    }) => {
      if (featuredVideosStatus === LOAD_STATE.LOADING) return <Loading text="Loading creator videos" />;

      if (featuredVideosStatus === LOAD_STATE.ERROR || featuredVideosStatus === LOAD_STATE.EMPTY) return null;

      return (
        <YouTubeVideoTrackCarousel
          className={classes('youtube-video-tracks-slice', className, styles.wrapper)}
          videos={featuredVideos}
          heading="Let other creators inspire you"
        />
      );
    }
  )
);
